import { render } from "./Box.ce.vue?vue&type=template&id=449553ff&scoped=true"
import script from "./Box.ce.vue?vue&type=script&lang=js"
export * from "./Box.ce.vue?vue&type=script&lang=js"

import _style_0 from "./Box.ce.vue?vue&type=style&index=0&id=449553ff&inline&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-449553ff"]])

export default __exports__